// API Configuration with Environment Variables
// Following Principios de Desarrollo: código modular y DRY

const getEnvVar = (key: string, defaultValue: string): string => {
  return (import.meta as any).env[key] || defaultValue;
};

// Get the appropriate default API base URL based on environment
const getDefaultApiBaseUrl = (): string => {
  // In development, use the proxy setup
  if (import.meta.env.DEV) {
    return '/api';
  }
  
  // In production, if no environment variable is set, try to infer the backend URL
  // This allows for flexible deployment configurations
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    // If frontend is on scoutmind-frontend.onrender.com, backend should be on scoutmind.onrender.com
    if (currentOrigin.includes('scoutmind-frontend.onrender.com')) {
      return 'https://scoutmind.onrender.com/api';
    }
    // If frontend is on scoutmind.onrender.com (same domain deployment), use same origin
    if (currentOrigin.includes('scoutmind.onrender.com')) {
      return `${currentOrigin}/api`;
    }
  }
  
  // Fallback to localhost for development
  return 'http://localhost:5051/api';
};

// API Base URLs from environment variables
export const API_BASE_URL = getEnvVar('VITE_API_BASE_URL', getDefaultApiBaseUrl());

// API endpoints configuration
export const API_ENDPOINTS = {
  // Main API endpoints
  auth: '/api/auth',
} as const;

// Helper function to build full URLs
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = API_BASE_URL;
  return `${baseUrl}${endpoint}`;
};

// Export for backward compatibility
export { API_BASE_URL as default };
